import styled from 'styled-components';
import * as UI from 'components/modules/UI/ui';
import cross from './cross-white.png';

export const Section = styled(UI.Section)`
  position: relative;

  display: flex;
  flex-direction: column-reverse;
  height: auto;

  background-repeat: no-repeat;
  background-position: 0 0;
  background-size: cover;

  background-color: ${({ active, activeBackgroundColor, backgroundColor }) =>
    (active ? activeBackgroundColor : backgroundColor)};
  transition: background-color 0.5s ease;

  @media (min-width: 1024px) {
    height: ${({ height }) => (height ? `${height}vh` : '90vh')};
    flex-direction: ${({ reversed }) => (reversed ? 'row-reverse' : 'row')};
  }
`;

export const BackgroundOverlay = styled(UI.BackgroundOverlayNarrow)`
  /* z-index: -1; */
`;

export const SliderWrapper = styled.div`
  position: relative;

  width: 100%;
  height: 65vw;
  overflow: hidden;

  transition: width 0.5s ease, flex-shrink 0.5s ease;

  @media (min-width: 1024px) {
    height: auto;
    width: ${({ active }) => (active ? '100%' : '50vw')};
    flex-shrink: ${({ active }) => active && '0'};
  }
`;

export const Overlay = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  width: 100vw;
  height: 66vh;
  transform: translate(-50%, -50%);

  z-index: ${({ active }) => (active ? 0 : 1)};
  cursor: ${({ active }) =>
    (active ? `url(${cross}) 18.5 16.5, not-allowed` : 'pointer')};
`;

export const TextWrapper = styled.div`
  position: relative;
  display: flex;
  flex-shrink: 0;
  align-items: flex-start;
  width: 100%;
  overflow: hidden;

  transition: transform 0.2s ease;

  @media (min-width: 1024px) {
    flex-direction: column;
    text-align: ${({ textHorizAlign }) => textHorizAlign};
    justify-content: ${({ textAlign }) => textAlign};
    width: 50%;
    transform: ${({ hidden, reversed }) => {
    if (!hidden) return 'none';
    return reversed ? 'translateX(-100%)' : 'translateX(100%)';
  }};
  }
`;

export const Img = styled.img`
  display: block;
  width: 100%;
  height: 100%;

  object-fit: cover;
  object-position: 50% 50%;
`;

export const TextContainer = styled(UI.HalfContainerNarrow)`
  @media (max-width: 1024px) {
    margin-bottom: 24px;
  }
`;



// WEBPACK FOOTER //
// ./src/components/modules/SliderDesktopSection/styled.js